import { altAttribute } from 'utils/imageHelpers';

// Decorative images do specify an empty alt-tag
// https://www.w3.org/WAI/tutorials/images/decorative/

/** @deprecated use Image from Commons instead */
export default function DecorativeImage({ alt, ...others }) {
  let altAttr = alt ? alt : altAttribute(others.src);

  return <img {...others} alt={altAttr} title={altAttr} />;
}
